/**
 * @ngdoc directive
 * @name drvEmailList
 * 
 * @description
 * Used for displaying the supplied emails in a list.
 * Note that this directive does NOT retrieve the emails.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmailList', drvEmailList);

    drvEmailList.$inject = [];

    function drvEmailList() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: EmailListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                emails: '='
            },
            template:
                '<md-list flex="100">' +
	            '   <md-list-item class="md-2-line">' +
		        '       <div class="md-list-item-text">' +
			    '           <md-list layout="grid" layout-wrap>' +
				'               <md-list-item-text flex="20">' +
				'               	<h3>To</h3>' +
				'               </md-list-item-text>' +
				'               <md-list-item-text flex="25">' +
				'               	<h3>Subject</h3>' +
				'               </md-list-item-text>' +
				'               <md-list-item-text flex="15">' +
				'                	<h3>From</h3>' +
				'               </md-list-item-text>' +
				'               <md-list-item-text flex="10">' +
				'               	<h3>Status</h3>' +
				'               </md-list-item-text>' +
				'               <md-list-item-text flex="15">' +
				'               	<h3>Date</h3>' +
				'               </md-list-item-text>' +
                '               <md-list-item-text flex="10">' +
				'               	<h3>User</h3>' +
				'               </md-list-item-text>' +
			    '           </md-list>' +
		        '       </div>' +
	            '   </md-list-item>' +
	            '   <md-divider></md-divider>' +
	            '   <md-list-item class="md-2-line" ng-repeat="email in drvCtrl.emails">' +
		        '       <div flex="100" class="md-list-item-text list-item-header">' +
			    '           <md-list layout="grid" layout-wrap>' +
				'               <span flex="20">' +
				'               	<p ng-bind-html="drvCtrl.formatAddress(email.To)"></p>' +
				'               </span>' +
				'               <span flex="25">' +
				'               	<p><a ng-href="#/email/{{email.Id}}">{{email.Subject}}</a></p>' +
				'               </span>' +
				'               <span flex="15">' +
				'               	<p ng-bind-html="drvCtrl.formatAddress(email.From)"></p>' +
				'               </span>' +
				'               <span flex="10">' +
				'               	<p>{{email.Status}}</p>' +
				'               </span>' +
				'               <span flex="15">' +
				'           	    <p>{{email.Date | date:\'longDate\'}} {{email.Date | date:\'shortTime\'}}</p>' +
				'               </span>' +
				'               <span flex="10">' +
				'                   <a href="{{\'#/entities/\' + email.UpdatedBy}}">' +
                '                       {{email.UpdatedByUserName}}' +
                '                   </a>' +
				'               </span>' +
				'           </md-list>' +
		        '       </div>' +
                '       <md-divider ng-if="!$last"></md-divider>' +
	            '   </md-list-item>' +
                '</md-list>'
        };
        return directive;

        function EmailListCtrl() {
            var drvCtrl = this;

            drvCtrl.formatAddress = formatAddress;

            /**
             * Formats the list of email addresses into a user friendly format
             *
             * @returns {string} Returns a 'user friendly' representation in HTML format containing the supplied email addresses
             */
            function formatAddress(addresses) {
                var result = '';

                angular.forEach(addresses, function (address) {
                    if (result !== '') {
                        result += ', ';
                    }

                    var emailAddressLabel = '';
                    if (!_.isNil(address.Name) && address.Name !== '') {
                        emailAddressLabel += address.Name;
                    } else {
                        emailAddressLabel += address.Value;
                    }

                    if (!_.isNil(address.EntityDetails) && !_.isNil(address.EntityDetails.Id) && address.EntityDetails.Id !== '') {
                        result += '<a href="#/entities/' + address.EntityDetails.Id + '">' + emailAddressLabel + '</a>';
                    } else {
                        result += emailAddressLabel;
                    }
                });


                return result;
            }
        }
    }
})();